module.exports = __webpack_public_path__ + "img/about_h5.c59c129e.png";